// extracted by mini-css-extract-plugin
export default {"heading":"_2RYV1xRl3MfqV1yZs8Czgh","paragraph":"DWVq7U1D0tMESDDTvBz2E","disclaimer":"_3gFIL4tHWx6NzNvI2jPaf_"};